export var backgroundGradient = '$_2vju2';